module.exports = __webpack_public_path__ + "img/2_icn_leather_jacket.3f1d52d8.png";